<template>
  <div class="pp-search-suggestion">
    <router-link
      :to="{
        name: 'product',
        params: { product_slug: product.slug, group_slug: product.group_slug },
      }"
      class="pp-search-suggestion__link"
    >
    </router-link>
    <div class="pp-search-suggestion__head">
      <div class="pp-search-suggestion__image-box">
        <img
          :src="img_url + product.image"
          alt=""
          class="pp-search-suggestion__image"
        />
      </div>
    </div>
    <div class="pp-search-suggestion__body">
      <p class="pp-search-suggestion__product-name">{{ product.name }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "SearchSuggestion",
  data() {
    return {
      img_url: process.env.VUE_APP_IMG_URL,
    };
  },
  props: {
    product: {},
  },
};
</script>

<style scoped></style>
